import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { EmpresaLista } from 'Component/Empresa';
import Form, { Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import Parametros from 'Interface/Requisicao';
import { useRecuperarEmpresasQuery } from 'View/Service/Default/Empresas';

const regras = object({
  busca: string().optional().min(3, 'Deve ter mais que 3 letras'),
});

const Default = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isFetching, isLoading } = useRecuperarEmpresasQuery({
    page: searchParams.get('pagina') || 1,
    options: { busca: { termo: searchParams.get('busca') || '' } },
  } as Parametros);

  const filtrar = (
    dados: { busca: string },
    form: FormikHelpers<FormikValues>
  ) => {
    searchParams.set('busca', dados.busca);
    searchParams.set('pagina', '1');

    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Empresas"
        descricao="Listagem de empresas cadastrados no banco de dados"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
            <BotaoLink tema="success" icone="plus-lg" to="/empresas/adicionar">
              Adicionar
            </BotaoLink>
          </div>
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Campo name="busca" rotulo="Digite o que deseja buscar" />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={data?.empresas.length}
        redirecionar="/empresas/adicionar"
      />
      <div className="bg-white shadow-sm rounded">
        {data?.empresas?.map((empresa) => (
          <EmpresaLista
            key={`${empresa.id}-${empresa.modificado}`}
            dados={empresa}
          />
        ))}
      </div>
      <Paginacao dados={data?.paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Default;
